import { AnyFieldApi } from "@tanstack/react-form";
import classNames from "classnames";
import { PropsWithChildren } from "react";
import styles from "./FormField.module.css";

type Props = PropsWithChildren<{
  label?: string;
  field: AnyFieldApi;
  vertical?: boolean;
}>;

const FormField = ({ label, field, children, vertical = false }: Props) => {
  return (
    <div
      className={classNames(styles.formField, { [styles.vertical]: vertical })}
    >
      {label && (
        <label className={styles.label} htmlFor={field.name}>
          {label}
        </label>
      )}
      {children}
      <FieldInfo field={field} />
    </div>
  );
};

export const FieldInfo = ({
  field,
  align,
}: {
  field: AnyFieldApi;
  align?: "right";
}) => {
  return (
    <>
      {field.state.meta.isTouched && !field.state.meta.isValid ? (
        <span
          className={classNames(styles.info, {
            [styles.right]: align === "right",
          })}
        >
          {field.state.meta.errors.join(",")}
        </span>
      ) : null}
      {field.state.meta.isValidating ? "Validating..." : null}
    </>
  );
};

export default FormField;
